import { SectionInfoServant } from '../../../sections/servants/section_info_servant';
import { RegistrationAlertsServant } from '../../../course_scheduler/servants/registration_alerts_servant';
import { ICommand } from 'core-ts-types';
import { UnscheduledSectionServant } from '../../servants/unscheduled_section_servant';
import * as _4 from 'lodash';
import { ISection, ICampusSectionGroup } from '../../../../interfaces/scheduler_interfaces';
import { StringUtility } from 'utility-ts-type';
import { SectionSwapServant } from '../../../../swap/servants/section_swap_servant';
import { SwapFacade } from '../../../../swap/facades/swap_facade';
import { MultiSectionServant } from '../../../course_scheduler/servants/multi_section_servant';
import { ScheduledSectionsQuery } from '../../../course_scheduler/queries/scheduled_sections_query';
import { ScheduleSectionFacade } from '../../../registration/facades/schedule_section_facade';
import { CommunicatorService } from 'ui-ng-component-communicator';

export interface ICampusSections {
  sections: ISection[];
  limitedSections: ISection[];
  name: string;
}

interface ISectionTileScope extends ng.IScope {
  section: ISection;
  $ctrl: UnscheduledSectionsByCampus;
  hideAddWaitlistPrompt: (confirmAdd: boolean) => void;
  resetSections: () => void;
}

export class UnscheduledSectionsByCampus {
  private sectionGroups: ICampusSectionGroup;
  private addWaitlistModal: any;
  private addSectionForSwap: () => void;
  private scheduleSection: () => void;
  private completeSectionMovement: () => void;
  private redirectAfterSchedule: () => void;
  private isSearchPage: boolean;
  private isSwapPage: boolean;
  private openedIndex: number;
  private isPermissionPinsFeatureEnabled: boolean;
  constructor(
    private calendarPreviewSetOnDrag: any,
    private calendarPreviewSetOnOver: any,
    private calendarPreviewDragEnd: any,
    private calendarPreviewSetSections: any,
    private phxDraggableService: any,
    private ngTermScheduleFlags: any,
    private appConfigModel: any,
    private calendarPreviewRemoveSections: any,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private ngRegistrationAlertsServant: RegistrationAlertsServant,
    private ngSectionSwapServant: SectionSwapServant,
    private ngMultiSectionServant: MultiSectionServant,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private $modal: any,
    private ngSectionInfoServant: SectionInfoServant,
    private scheduleSectionCommand: ICommand,
    private getCourseSchedulerCommand: ICommand,
    private waitlistSectionCommand: ICommand,
    private saveTermPinCommand: ICommand,
    private updateSeatAvailabilityCommand: ICommand,
    private loadStudentUnavailabilityCommand: ICommand,
    private viewMoreTimesCommand: ICommand,
    private getTermCoursesCommand: ICommand,
    private getTermPinCommand: ICommand,
    private getSectionDetailsCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService,
    private saveSelectedUnscheduledSectionCommand: ICommand,
    private removeSelectedUnscheduledSectionCommand: ICommand,
    private ngSwapFacade: SwapFacade,
    private ngScheduleSectionFacade: ScheduleSectionFacade
  ) {}

  $onInit() {
    this.isSearchPage = _4.includes(this.$state.current.name || '', 'search');
    this.openedIndex = 0;
    this.isPermissionPinsFeatureEnabled = this.appConfigModel.model.member_features['reg-class_permission'];
  }
  getAccordionTitle(campus: ICampusSections) {
    return campus.name === 'Online Classes'
      ? `Online Classes (${campus.sections.length})`
      : `${StringUtility.truncateString(25, campus.name)} (${campus.sections.length})`;
  }
  canDragSection(section: ISection) {
    return this.ngUnscheduledSectionServant.canDragSection(section);
  }

  selectedIndexChanged(event: any) {
    const index = event.target.selectedIndex;
    const sections = _4.get(this.sectionGroups[index], 'sections', false);
    if (sections) {
      this.toggleCampus(sections);
    }
  }

  isSectionReadyForWaitListing(section: ISection) {
    if (!this.ngUnscheduledSectionServant.isSectionFull(section)) {
      return false;
    }
    if (this.ngTermScheduleFlags.isFullSectionsSchedulingEnabled()) {
      return false;
    }
    return this.ngUnscheduledSectionServant.canAddToWaitlist(section);
  }

  /* tslint:disable:cognitive-complexity */
  moveSectionTile(draggableElements: any) {
    const target = draggableElements[1];

    if (!target.className.includes('drag-area')) {
      return;
    }
    const scope: ISectionTileScope = angular.element(_4.first(draggableElements)).scope();
    scope.$ctrl = this;

    const isConflictingSection = this.ngUnscheduledSectionServant.isSectionConflicting(scope.section);
    const isWaitlistSection = this.isSectionReadyForWaitListing(scope.section);

    scope.resetSections = () => {
      if (this.isSearchPage) {
        this.$state.go('my.schedule.registration.search');
      } else {
        this.$state.go(
          'my.schedule.registration.courseSections',
          { courseId: scope.section._course.id, sectionTypeId: scope.section.section_type },
          { reload: true }
        );
      }
    };

    this.completeSectionMovement = () => {
      if (this.ngSectionSwapServant.isInSwapMode()) {
        this.addSectionForSwap();
      } else {
        this.scheduleSection();
      }
    };

    this.addSectionForSwap = () => {
      this.ngSwapFacade.saveSwapToAndRedirect(scope.section);
    };

    this.scheduleSection = () => {
      this.ngScheduleSectionFacade.scheduleSection(scope.section);
    };

    if (isConflictingSection) {
      this.phxDraggableService.getDrake('unscheduledSectionsBag').cancel();
      this.getSectionDetailsCommand(scope.section.id).then(() => {
        this.ngComponentCommunicatorService.publish('OPEN_CONFLICT_PROMPT');
      });
    } else if (isWaitlistSection) {
      this.phxDraggableService.getDrake('unscheduledSectionsBag').cancel();
      this.getTermPinCommand(this.$stateParams.termId).then(() => {
        this.getSectionDetailsCommand(scope.section.id).then(() => {
          this.ngComponentCommunicatorService.publish('OPEN_WAITLIST_PROMPT');
        });
      });
    } else {
      this.completeSectionMovement();
    }
  }

  hideAddWaitlistPrompt(confirmAdd: boolean) {
    this.addWaitlistModal.hide();
    this.calendarPreviewDragEnd();
    this.calendarPreviewRemoveSections();
    if (!confirmAdd) {
      this.$state.reload();
    }
  }

  toggleCampus(campus: ICampusSections) {
    this.updateInitialSeats(campus);
  }

  updateInitialSeats(campus: ICampusSections) {
    if (this.ngTermScheduleFlags.getNumberOfSeatsRequestsPerCourse() !== 0) {
      const SectionIdsForInitialOpen = _4.compact(
        _4.map(_4.take(campus.sections, this.ngTermScheduleFlags.getNumberOfSeatsRequestsPerCourse()), 'id')
      );
      this.updateSeatAvailabilityCommand(SectionIdsForInitialOpen);
    }
  }

  updateFirsOpenedCampuSeats(campus: ICampusSections, index: number) {
    if (index === 0) {
      this.updateInitialSeats(campus);
    }
  }

  viewMoreTimes(campus: ICampusSections) {
    this.viewMoreTimesCommand(campus);
    if (this.ngTermScheduleFlags.getNumberOfSeatsRequestsPerCourse() !== 0) {
      const sectionsLength = Math.min(
        campus.limitedSections.length + this.ngTermScheduleFlags.getNumberOfSeatsRequestsPerCourse(),
        campus.sections.length
      );
      const nextSectionIds = _4.compact(
        _4.map(campus.sections.slice(campus.limitedSections.length, sectionsLength), 'id')
      );
      this.updateSeatAvailabilityCommand(nextSectionIds);
    }
  }

  areAllSectionsDisplayed(campus: ICampusSections, displayedFlags: any) {
    return _4.isEqual(campus.sections.length, campus.limitedSections.length);
  }
}

class UnscheduledSectionsByCampusComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      sectionGroups: '<',
      campus: '<',
      sectionKind: '@',
      allDisplayedFlags: '<'
    };
    this.controller = UnscheduledSectionsByCampus;
    this.templateUrl =
      'capability-ng-scheduler/src/views/unscheduled_sections/components/unscheduled_sections_by_campus/unscheduled_sections_by_campus.html';
  }
}
angular
  .module('capability-ng-scheduler')
  .component('unscheduledSectionsByCampus', new UnscheduledSectionsByCampusComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/components/unscheduled_sections_by_campus/unscheduled_sections_by_campus.ts